<template>
  <div class="c-tab-data">
    <div class="tab-data__wrapper">
      <div class="btns">
        <ElButton @click="fileDownloadClick" :loading="loading">数据导出</ElButton>
        <ElButton @click="modalColumn = true" :loading="loading">自定义列</ElButton>
      </div>
      <Viewport v-model="height">
        <el-table
          width="100%"
          ref="table"
          class="summary-el-table-styles common-el-table-styles"
          v-loading="loading"
          :data="tableData"
          :height="height - 6"
          :summary-method="summaries"
          show-summary
          border
          stripe
          @header-dragend="headerDragend"
          @sort-change="sortChange"
        >
          <el-table-column
            v-for="(col, idx) in tableCol"
            :key="idx"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
            :sortable="col.sortable"
            :sort-orders="['descending', 'ascending', null]"
          >
            <template slot-scope="{ row }">
              <div v-if="col.key === 'switch'">
                <i-Switch
                  v-model="row.switchStatus"
                  size="small"
                  :loading="row.optLoading"
                  :true-value="0"
                  :false-value="1"
                  @on-change="changeActive(row)"
                />
              </div>
              <div class="material-name" v-else-if="col.key === 'material'">
                <el-popover v-model="row.showPop" placement="right-start" title="素材" trigger="manual">
                  <div v-if="row.showPop">
                    <el-image
                      v-if="[IMAGE_TYPES.IMAGE, IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.PLAYABLE].includes(row.type)"
                      :src="row.imageUrl"
                      style="width: 320px"
                      fit="contain"
                    ></el-image>
                    <video
                      autoplay
                      controls
                      style="max-width: 420px; max-height: 320px"
                      v-if="row.type === IMAGE_TYPES.VIDEO"
                      :src="row.videoUrl"
                    ></video>
                  </div>
                  <div class="material-item" slot="reference" @mouseenter="row.showPop = true" @mouseleave="row.showPop = false">
                    <video style="height: 100%" v-if="row.type === IMAGE_TYPES.VIDEO" :src="row.videoUrl"></video>
                    <el-image
                      style="max-width: 110px"
                      v-if="[IMAGE_TYPES.IMAGE, IMAGE_TYPES.GROUP_IMAGE, IMAGE_TYPES.PLAYABLE].includes(row.type)"
                      fit="cover"
                      :src="row.imageUrl"
                    ></el-image>
                  </div>
                </el-popover>

                <div class="material-id">
                  <div style="margin-bottom: 10px">{{ row.imageName }}</div>
                  <div>ID：{{ row.mediaMaterialId }}</div>
                </div>
              </div>
              <div class="creative-name" v-if="col.key === 'adCreativeName'">
                <div>创意名称：{{ row.adCreativeName }}</div>
                <div>创意ID：{{ row.adCreativeId }}</div>
              </div>
              <div class="material-action" v-else-if="col.key === 'action'">
                <el-button type="text" size="mini" :loading="row.removeLoading" @click="handleRemoveRestore(row, 1)">移除</el-button>
                <el-button type="text" size="mini" :loading="row.restoreLoading" @click="handleRemoveRestore(row, 2)">恢复</el-button>
              </div>
              <span v-else-if="col.key.indexOf('Rate') > -1">{{ row[col.key] | toPercentFixed }}</span>
              <span v-else-if="col.key.indexOf('Retain') > -1">{{ row[col.key] | toPercentFixed }}</span>
              <span
                v-else-if="
                  [
                    'createRoleCost',
                    'newPayCost',
                    'amount',
                    'newRolePayCntCost',
                    'paperUseAmount',
                    'pv',
                    'clickNum',
                    'downNum',
                    'newUserNum',
                    'createRoleNum',
                    'newRoleNum',
                    'newDeviceMoney',
                    'newRoleMoney'
                  ].includes(col.key)
                "
                >{{ row[col.key] | toThousands }}</span
              >
              <span v-else>{{ row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      name="detailMaterialCustomColumn"
      v-model="modalColumn"
      :data="rawTableCols"
      :subTitle="['', '报表数据', '留存数据']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import columns from '../../../data/tab_material_columns'
import { isArray, isEmpty } from '@/common/js/utils'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { getPlanMaterialDetail, materialSwitch, materialRemoveRestore } from '@/api/ptom.data.model'
import { HOST_API } from '@/api/config'
import { IMAGE_TYPES } from '@/views/material/uploading/consts.js'

import CustomColumn from '@/components/converter/custom-column2.vue'

export default {
  name: 'TabData',
  // mixins: [mixinTable],
  components: { CustomColumn },
  props: {
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    },
    detailTime: {
      type: Array
    },
    mediaId: {
      type: Number
    },
    subMediaId: {
      type: [Number, String],
      default: null
    },
    planId: {
      type: Number
    }
  },
  computed: {
    tableCol() {
      const checkedList = this.tableColumns.filter((ret) => ret.checked)
      if (this.mediaId === 10) {
        checkedList.unshift({
          title: '开关',
          key: 'switch',
          width: 40,
          exclude_export: true
        })
      }
      // 暂时不开发此功能：腾讯V3、巨量引擎2.0、巨量智擎素材移除/恢复操作列
      // const subMediaId = Number(this.subMediaId)
      // if ((this.mediaId === 10 && [2, 3].includes(subMediaId)) || (this.mediaId === 16 && subMediaId === 3)) {
      //   checkedList.unshift({
      //     title: '操作',
      //     key: 'action',
      //     width: 100,
      //     exclude_export: true
      //   })
      // }
      return checkedList
    }
  },
  methods: {
    fileDownloadClick() {
      const [begin, end] = this.detailTime || []
      const url = `${HOST_API}/api/ptom/planDataDetail/downImageDetailData?`

      const querystring = new URLSearchParams()
      querystring.append('sessionid', this.$store.state.token)
      querystring.append('gameId', this.productId)
      querystring.append('chlId', this.chlUserId)
      querystring.append('sourceId', this.sourceId)
      querystring.append('beginTime', begin)
      querystring.append('endTime', end)
      querystring.append('sort', this.sort)
      querystring.append('order', this.order)

      window.open(url + querystring.toString())
    },
    getData() {
      const [beginTime, endTime] = this.detailTime || []
      const params = {
        gameId: this.productId,
        chlId: this.chlUserId,
        sourceId: this.sourceId,
        beginTime,
        endTime,
        sort: this.sort,
        order: this.order
      }
      this.loading = true
      getPlanMaterialDetail(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { rows, sumdata } = data
            if (isArray(rows) && sumdata) {
              this.sumdata = sumdata
              this.tableData = rows

              this.$nextTick(this.$refs.table.doLayout)
            } else {
              this.tableData = []
            }
          }
        })
        .catch((e) => {
          this.loading = false
          this.tableData = []
          this.total = 0
        })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      if (!data) return sums
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const twoDecimal = [
          'createRoleCost',
          'throusandProfitPvCost',
          'newPayCost',
          'amount',
          'newRolePayCntCost',
          'paperUseAmount',
          'pv',
          'clickNum',
          'downNum',
          'newUserNum',
          'createRoleNum',
          'newRoleNum',
          'newDeviceMoney',
          'newRoleMoney'
        ]
        if (isEmpty(val)) sums[index] = ''
        else if (twoDecimal.includes(prop)) sums[index] = toThousands(val)
        else if (prop.indexOf('Rate') > -1) sums[index] = toPercentFixed(val)
        else if (prop.indexOf('Retain') > -1) sums[index] = toPercentFixed(val)
        else sums[index] = val
      })
      return sums
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.modalColumn = false
    },
    sortChange({ prop, order }) {
      const orderType = {
        ascending: 'asc',
        descending: 'desc'
      }
      this.order = orderType[order]
      this.sort = prop
      // this.pageIndex = 1
      this.getData()
    },
    changeActive(row) {
      const { mediaMaterialId, switchStatus } = row
      const params = {
        planId: this.planId,
        mediaId: this.mediaId,
        mediaMaterialId,
        switchStatus
      }
      this.$set(row, 'optLoading', true)
      materialSwitch([params]).then((data) => {
        this.$set(row, 'optLoading', false)
        const { failMsg } = data && data.length ? data[0] : {}
        if (failMsg) {
          this.$Message.error(failMsg)
          this.$set(row, 'switchStatus', switchStatus ? 0 : 1)
        } else {
          this.$Message.success('操作成功')
        }
      })
    },
    handleRemoveRestore(row, op) {
      const { mediaMaterialId, adCreativeId } = row
      // 巨量智擎（头条 mediaId=10 且 subMediaId=3）无广告/创意层级，adCreativeId 非必填
      const isZhiqing = this.mediaId === 10 && Number(this.subMediaId) === 3
      if (!mediaMaterialId || (!isZhiqing && !adCreativeId)) {
        this.$Message.error(isZhiqing ? '缺少素材ID，无法操作！' : '缺少素材ID或创意ID，无法操作！')
        return
      }
      const opName = op === 1 ? '移除' : '恢复'
      this.$confirm(`确认${opName}素材（ID：${mediaMaterialId}）吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const loadingKey = op === 1 ? 'removeLoading' : 'restoreLoading'
          this.$set(row, loadingKey, true)
          materialRemoveRestore({
            planId: this.planId,
            adCreativeId,
            mediaMaterialId,
            op
          })
            .then((data) => {
              this.$set(row, loadingKey, false)
              if (data === false) return
              this.$Message.success(`${opName}成功`)
              this.getData()
            })
            .catch(() => {
              this.$set(row, loadingKey, false)
            })
        })
        .catch(() => {})
    }
  },
  watch: {
    detailTime() {
      // this.pageIndex = 1
      this.getData()
    }
  },
  data() {
    return {
      IMAGE_TYPES,
      rawTableCols: columns,
      tableColumns: [],
      height: 330,
      loading: false,
      modalColumn: null,
      tableData: [],
      sumdata: null,
      order: '',
      sort: ''
    }
  },
  created() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-tab-data {
  height: 100%;

  .material-name {
    display: flex;
    align-items: center;
    .material-item {
      height: 60px;
      display: flex;
      align-items: center;
    }

    .material-id {
      margin-left: 5px;
    }
  }

  .btns {
    text-align: right;
    padding: 5px 0;
  }

  .material-action {
    .el-button {
      padding: 0 2px;
    }
  }
}
</style>
